import React, { useEffect, useState } from 'react';
import { useBreadcrumbs } from '../hooks';
import { Header, Table, Label } from 'react-frontier';
import { Link } from 'react-router-dom';
import { addCommas } from '../SiteUtil';
import moment from 'moment';
import API from '../API';

interface Payout{
	payout_id: number,
	date_start: number,
	date_end: number,
	date_created: number,
	user_creator_name: string,
	employee_count: number,
	payment_count: number,
	total_amount: number,
	paid_amount: number,
	pending_amount: number,
	completed: number,
}

var EmploymentPayouts = ()=>{
	var { setTitle } = useBreadcrumbs();
	var [loadError, setLoadError] = useState<string>(null);
	var [payouts, setPayouts] = useState<Payout[]>(null);

	var load = ()=>{
		setPayouts(null);
		API.listEmploymentPayouts(100, 0).then(res=>{
			if(res.error) return setLoadError(res.message);
			setPayouts(res.data);
		}).catch(()=> setLoadError('Hubo un error cargando los pagos (LCL-1)'));
	};

	useEffect(()=>{
		setTitle('Nómina');
		load();
	}, []);

	var payoutTable = (title: string, list: Payout[], empty: string)=> (
		<Table
			striped fitted
			title={title}
			className='table'
			style={{ maxWidth: 850, margin: 'auto', marginTop: 20 }}
			headers={['ID', 'Semana', 'Empleados', 'Pagos', 'Total', 'Pendiente', 'Estado']}
			collapsingIndexes={[0, 2, 3, 6]}
			centeredIndexes={[2, 3, 6]}
		>
			{list.length !== 0 ? list.map(p => (
				<Table.Row
					selectable
					striped
					compact
					key={p.payout_id}
					as={Link}
					to={`/employees/payouts/${p.payout_id}`}
					collapsingIndexes={[0, 2, 3, 6]}
					centeredIndexes={[2, 3, 6]}
					data={[
						p.payout_id,
						`${moment.unix(p.date_start).format('DD/MM/YY')} - ${moment.unix(p.date_end).format('DD/MM/YY')}`,
						p.employee_count,
						p.payment_count,
						'$' + addCommas(p.total_amount || 0),
						'$' + addCommas(p.pending_amount || 0),
						<Label color={p.completed ? 'green' : 'orange'}>{p.completed ? 'Pagada' : 'Pendiente'}</Label>
					]}
				/>
			)) : (
				<Table.Cell row className='empty' colSpan={7}>{empty}</Table.Cell>
			)}
		</Table>
	);

	if(loadError) return <Header text='Error' subtext={loadError} />
	if(!payouts) return <Header text='Cargando pagos' loading style={{ marginTop: 40 }} centered />

	return <div>
		{payoutTable('Pendientes', payouts.filter(p => !p.completed), 'No hay pagos pendientes')}
		{payoutTable('Completadas', payouts.filter(p => !!p.completed), 'No hay pagos pagados')}
	</div>
}

export default EmploymentPayouts;
